import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, CardBody, Input, Collapse, Label } from 'reactstrap';
import { Search } from 'react-feather';
import { Filter } from '../../../../Constant';
import { H5, Btn } from '../../../../AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters } from '../../../../Features/Learning/Vouchers/voucherSlice';
import { fetchVoucher } from '../VoucherUtils';
import RadioFilter from '../../Common/Filter/RadioFilter';

const FindVoucher = () => {
  const [isFilter, setIsFilter] = useState(true);
  const [isExpired, setIsExpired] = useState("all");
  const dispatch = useDispatch()
  const filters = useSelector(state => state.Voucher.filters)

  const handleSortBy = (e) => {
    const filterValue = e.target.value;
    dispatch(setFilters({
      ...filters,
      [e.target.name]: filterValue,
    }));
  };

  const handleClickSearch = (e) => {
    e.preventDefault()
    const newFilters = {
      ...filters,
      'page': 1,
    };
    dispatch(setFilters(newFilters));
    fetchVoucher(dispatch, newFilters);
  }

  const handleResetFilter = (e) => {
    e.preventDefault()
    const newFilters = {
      ...filters,
      'filter[id]': '',
      'filter[code]': '',
      'sort': '',
      'filter[valid_status]': "all"
    }
    dispatch(setFilters(newFilters));
    fetchVoucher(dispatch, newFilters);
  }

  useEffect(() => {
    setIsExpired(filters['filter[valid_status]'])
  }, [])

  const handleFilterExpired = (e) => {
    const { value } = e.target
    setIsExpired(value)
    let newFilters
    if (value === "all") {
      newFilters = {
        ...filters,
        'filter[valid_status]': value,
      }
    } else if (value === "expired") {
      newFilters = {
        ...filters,
        'filter[valid_status]': value,
      }
    } else if (value === "active") {
      newFilters = {
        ...filters,
        'filter[valid_status]': value,
      }
    }

    dispatch(setFilters(newFilters));
  }

  return (
    <Fragment>
      <Col xl="12">
        <Card>
          <CardHeader>
            <H5 attrH5={{ className: 'mb-0' }} >
              <Btn attrBtn={{ className: 'btn btn-link ps-0', onClick: () => setIsFilter(!isFilter), color: 'transperant', datastoggle: 'collapse', databstarget: '#collapseicon', ariaexpanded: 'true', ariacontrols: 'collapseicon' }} >Find Kupon</Btn>
            </H5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <div className="collapse show" id="collapseicon" aria-labelledby="collapseicon" data-parent="#accordion">
              <CardBody className="filter-cards-view animate-chk">
                <div className="job-filter">
                  <div className="faq-form">
                    <Input className="form-control" type="text" placeholder="Cari kode kupon.."
                      value={filters['filter[code]']}
                      onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                      onChange={(e) => {
                        dispatch(setFilters({
                          ...filters,
                          'filter[code]': e.target.value
                        }));
                      }}
                    />
                    <Search className="search-icon" />
                  </div>
                </div>
                <RadioFilter sort={'Sort by :'}>
                  <Label className="d-block" htmlFor="sort-maxDiscount">
                    <Input className="radio_animated" id="sort-maxDiscount" type="radio" name="sort"
                      checked={filters.sort === '-discount'}
                      value="-discount"
                      onChange={handleSortBy}
                    />
                    {'Diskon Terbesar'}
                  </Label>
                  <Label className="d-block" htmlFor="sort-minDiscount">
                    <Input className="radio_animated" id="sort-minDiscount" type="radio" name="sort"
                      checked={filters.sort === 'discount'}
                      value="discount"
                      onChange={handleSortBy}
                    />
                    {'Diskon Terkecil'}
                  </Label>
                  <Label className="d-block" htmlFor="sort-new">
                    <Input className="radio_animated" id="sort-new" type="radio" name="sort"
                      checked={filters.sort === '-id'}
                      value="-id"
                      onChange={handleSortBy}
                    />
                    {'Terbaru'}
                  </Label>
                  <Label className="d-block" htmlFor="sort-old">
                    <Input className="radio_animated" id="sort-old" type="radio" name="sort"
                      checked={filters.sort === 'id'}
                      value="id"
                      onChange={handleSortBy}
                    />
                    {'Terlama'}
                  </Label>
                  <Label className="d-block" htmlFor="sort-az">
                    <Input className="radio_animated" id="sort-az" type="radio" name="sort"
                      checked={filters.sort === 'code'}
                      value="code"
                      onChange={handleSortBy}
                    />
                    {'A-Z'}
                  </Label>
                  <Label className="d-block" htmlFor="sort-za">
                    <Input className="radio_animated" id="sort-za" type="radio" name="sort"
                      checked={filters.sort === '-code'}
                      value="-code"
                      onChange={handleSortBy}
                    />
                    {'Z-A'}
                  </Label>
                </RadioFilter>
                <RadioFilter sort={'Status Valid :'}>
                  <Label className="d-block" htmlFor="filter-all">
                    <Input className="radio_animated" id="filter-all" type="radio" name="expired"
                      checked={isExpired === 'all'}
                      value="all"
                      onChange={handleFilterExpired}
                    />
                    {'Semua'}
                  </Label>
                  <Label className="d-block" htmlFor="filter-active">
                    <Input className="radio_animated" id="filter-active" type="radio" name="expired"
                      checked={isExpired === 'active'}
                      value="active"
                      onChange={handleFilterExpired}
                    />
                    {'Active'}
                  </Label>
                  <Label className="d-block" htmlFor="filter-expired">
                    <Input className="radio_animated" id="filter-expired" type="radio" name="expired"
                      checked={isExpired === 'expired'}
                      value="expired"
                      onChange={handleFilterExpired}
                    />
                    {'Expired'}
                  </Label>
                </RadioFilter>
                <div className="row">
                  <div className="col-md-6">
                    <Btn attrBtn={{ color: 'primary text-center p-1', onClick: handleClickSearch }}>{Filter}</Btn>
                  </div>
                  <div className="col-md-6">
                    <Btn attrBtn={{ color: 'warning text-center p-1', onClick: handleResetFilter }}>{'Reset'}</Btn>
                  </div>
                </div>
              </CardBody>
            </div>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default FindVoucher;